import { NavLink } from 'react-router';
import { strings } from '@/theme';
import { Icon } from '../ui';

// Labels come from src/theme/strings.ts, the same copy the app's tab bar uses. Discover is
// switched off for now on both clients (/discover redirects to Build).
//
// Account is a third tab here where the phone has an avatar in the header (AccountAvatar). It was
// missing on the web altogether (F6, 2026-09-30): the trial checkout says "Cancel any time", and
// Manage subscription — the only way to cancel — Sign out, Delete account, Support and Credits
// all live on /account, which nothing linked to. Somebody from an ad who wanted to cancel before
// day 8 had to guess the address or be charged. A tab rather than an avatar because this bar is
// the one piece of chrome on every tab page at both widths; the label is the phone avatar's name.
const TABS = [
  { to: '/', icon: 'build', activeIcon: 'buildActive', label: strings.tabs.build },
  { to: '/my-apps', icon: 'myApps', activeIcon: 'myAppsActive', label: strings.tabs.myApps },
  { to: '/account', icon: 'account', activeIcon: 'accountActive', label: strings.account.a11yAvatar },
] as const;

/** One component, two layouts: a bottom bar on phones, a left rail from 768px, in CSS. */
export default function TabBar() {
  return (
    <nav aria-label="Main" className="tabbar glass">
      {TABS.map((t) => (
        <NavLink key={t.to} to={t.to} end={t.to === '/'} className="tab">
          {({ isActive }) => (
            <>
              <Icon name={isActive ? t.activeIcon : t.icon} size={24} color={isActive ? 'var(--color-primary)' : 'var(--color-text-muted)'} />
              <span className="type-micro">{t.label}</span>
            </>
          )}
        </NavLink>
      ))}
    </nav>
  );
}
